import { render, staticRenderFns } from "./DummyInvoice.vue?vue&type=template&id=7c7a19e4&scoped=true&"
import script from "./DummyInvoice.vue?vue&type=script&lang=js&"
export * from "./DummyInvoice.vue?vue&type=script&lang=js&"
import style0 from "./DummyInvoice.vue?vue&type=style&index=0&id=7c7a19e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7a19e4",
  null
  
)

export default component.exports